import React from "react";
import { Outlet } from "react-router-dom";
import AdminSidebar from "./AdminSidebar";
import "./Adminsidebar.css";
/**
 * AdminLayout
 * Sidebar is fully self-contained — it manages its own collapsed/mobile
 * state and exposes its current width as the --admin-sidebar-current-width
 * CSS variable on the document root (see the effect in AdminSidebar.jsx).
 * Main content just reads that variable, so it always matches whatever
 * space the sidebar is actually taking up, with no props or duplicated
 * state to keep in sync by hand.
 */
const AdminLayout = () => {
  return (
    <div className="min-h-screen bg-[#FBF7F0]">
      <AdminSidebar />

      <main
        className="min-h-screen  p-3 sm:p-4 transition-[margin-left] duration-300 ease-in-out"
        style={{ marginLeft: "var(--admin-sidebar-current-width, 0px)" }}
      >
        <div className="overflow-x-auto">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;
